import { Expense, RightEnum } from "@finway-group/shared/lib/models"
import { DatePicker } from "antd"
import moment from "moment"
import React from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { AuthzService, ExpenseService, NotificationService } from "~Shared/services"
import { patchExpense } from "../../../../../shared/store/actions/expense/expenseActions"
import { formatExpenseDate } from "../../../../../shared/utils/date.utils"
import { isExpenseArchived } from "../../../../../shared/utils/expense.utils"
import { getPopupAnchor } from "../../../../../shared/utils/popup.utils"

interface InvoiceDatePaidAtFieldProps {
    expense: Expense
    setIsExpenseUpdating?: React.Dispatch<React.SetStateAction<boolean>>
    areInputsDisabled: boolean
}

export const InvoiceDatePaidAtField = ({ expense, setIsExpenseUpdating, areInputsDisabled }: InvoiceDatePaidAtFieldProps) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const archived = isExpenseArchived(expense)

    const datePaidAt = expense.datePaidAt ? moment(expense.datePaidAt) : moment()

    const isDatePaidAtEditable =
        expense.isReviewed() && AuthzService.isRightGrantedForLoggedInUser(RightEnum.EXPENSE__ALL__REVIEW) && ExpenseService.isExpenseEditableBasedOnArchive(archived)

    const onDatePaidAtChange = async (datePaidAt: any) => {
        try {
            await patchExpense(expense.id, { datePaidAt })(dispatch)
        } catch (err) {
            NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:request.edit.title"))
        } finally {
            setIsExpenseUpdating?.(false)
        }
    }

    if (isDatePaidAtEditable) {
        return (
            <li>
                <span className={`w-1/2 title label-required`}>{t("label:date_paid_at")}</span>
                <DatePicker
                    className="w-1/2"
                    value={datePaidAt}
                    format={moment.localeData().longDateFormat("L")}
                    placeholder={t("placeholder:request.date")}
                    onChange={onDatePaidAtChange}
                    getPopupContainer={getPopupAnchor()}
                    disabled={areInputsDisabled}
                />
            </li>
        )
    }

    return expense.isSuccessfullyProcessed() && expense.datePaidAt ? (
        <li>
            <span className="title">{moment(expense.datePaidAt).startOf("day").isAfter(moment()) ? t("label:to_be_paid_at") : t("label:date_paid_at")}</span>
            <span className="text">{formatExpenseDate(expense.datePaidAt)}</span>
        </li>
    ) : null
}
